import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.mscript = languageMap.pq = languageMap.powerquery = bracketIndenting()
